import {WarehouseDetailsReport} from "../models/Report";
import {WarehouseDetailsByProductReportTemplateData} from "./WarehouseDetailsByProductReportTemplateData";
import {WarehouseDetailsByProductReportImportTemplate} from "./WarehouseDetailsByProductReportImportTemplate";
import {cloneDeep} from "lodash";

export const getWarehouseDetailsByProductReportTemplate = (
    data: WarehouseDetailsReport[],
    selectedProduct: string,
    totalInputNeto: number,
    totalInputSrps: number,
    totalOutputNeto: number,
    totalOutputSrps: number
    ) => {
    return WarehouseDetailsByProductReportImportTemplate(
        prepareData(data, selectedProduct, totalInputNeto, totalInputSrps, totalOutputNeto, totalOutputSrps));
};

const prepareData = (
    documentData: WarehouseDetailsReport[],
    selectedProduct: string,
    totalInputNeto: number,
    totalInputSrps: number,
    totalOutputNeto: number,
    totalOutputSrps: number
    ) => {
    const templateData: WarehouseDetailsByProductReportTemplateData = {
        productName: selectedProduct,
        reportData: cloneDeep(documentData),
        totalInputNeto: totalInputNeto,
        totalInputSrps: totalInputSrps,
        totalOutputNeto: totalOutputNeto,
        totalOutputSrps: totalOutputSrps
    };

    return templateData;
};